// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3Lc42","resendInfoText":"OnGoingPaymentBox_resendInfoText__SKGBs"};